import React, {useContext} from "react"

// context
import {ShopContext} from "../../../context/ShopContext"

// components
import {Warning} from "../../controls"

function Warnings() {
  // shop context
  const shop = useContext(ShopContext)

  // no activities? no soup!
  if((shop.cartActivities || []).length === 0) {
    return null
  }

  // warnings
  let warnings = []

  // all participant should be equal
  let participantCounts = shop.cartActivities.map(a => a.ParticipantCount || 1)
  let participantCountsEqual = participantCounts.every(pc => pc === participantCounts[0])
  if(!participantCountsEqual) {
    warnings.push({
      key:'participantCount',
      text:[
        "Die von dir gewählten Aktivitäten weisen unterschiedliche Anzahl Teilnehmer auf. Das kann dazu führen, dass die beschenkten Personen nicht alles gemeinsam unternehmen können.",
        "Falls du das nicht möchtest, ändere einfach die Anzahl Teilnehmer."
      ]
    })
  }

  // all regions should match
  let regions = shop.cartActivities.map(a => a.RegionCode || '')
  let regionsEqual = regions.every(r => r === regions[0])
  if(!regionsEqual) {
    warnings.push({
      key:'regions',
      text:[
        "Die von dir gewählten Aktivitäten finden nicht in der gleichen Region statt. Das kann dazu führen, dass die beschenkte Person lange Reisewege auf sich nehmen muss.",
        "Falls Du das nicht möchtest, ändere einfach die Region."
      ]
    })
  }

  // no warnings? no render
  if(warnings.length === 0) {
    return null
  }

  // map warnings to Warning components
  let content = warnings.map(w => {
    return (
      <Warning key={w.key} text={w.text} />
    )
  })

  // render
  return (
    <div id="s-checkout-warnings">
      {content}
    </div>
  )
}

export default Warnings